export const planOptions = [25000, 50000, 100000, 200000];

// A promotional plan is named with a "PROMO - " prefix, e.g.
// "PROMO - Essentials Monthly 25K Saves/Exports $97". The account screens derive the tier by taking the first
// word of the plan name, which for those plans reads "PROMO". Drop the prefix first so a promo plan shows the
// tier the account is actually on (ATAI-590).
//
// Kept tier-agnostic rather than returning "Essentials", so a future "PROMO - Pro ..." plan reads correctly.
// The \b keeps a plan named "Promotional ..." out of it; a name without the prefix is unchanged.
const PROMO_NAME_PREFIX = /^\s*PROMO\b[\s-]*/i;

export const planTierName = (name) =>
  name ? name.replace(PROMO_NAME_PREFIX, '').split(' ')[0] : '';

export const sortedPlanOptions = (planOptions) => [...planOptions].sort((a, b) => {
    const priority = {
        "Essentials": 1,
        "Pro": 2,
        "Elite": 3
    };
    const getPriority = (name) => {
        if (!name) return 4; // Fallback for empty names
        if (name.includes("Essentials")) return priority["Essentials"];
        if (name.includes("Pro")) return priority["Pro"];
        if (name.includes("Elite")) return priority["Elite"];
        return 4; // Fallback for unknown plans (appear last)
    };
    return getPriority(a.name) - getPriority(b.name);
});
